interface DebugIngestPayload {
  hypothesisId: string;
  location: string;
  message: string;
  data: Record<string, unknown>;
}

const LOCAL_DEBUG_HOSTS = new Set(['localhost', '127.0.0.1']);
const DEBUG_ENDPOINT = 'http://127.0.0.1:7678/ingest/f50eb18e-83d8-4612-bf36-95591f519d6b';

export function sendLocalDebugIngest(payload: DebugIngestPayload): void {
  if (typeof window === 'undefined' || !LOCAL_DEBUG_HOSTS.has(window.location.hostname)) {
    return;
  }

  fetch(DEBUG_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Debug-Session-Id': '3afbee',
    },
    body: JSON.stringify({
      sessionId: '3afbee',
      runId: 'initial',
      ...payload,
      timestamp: Date.now(),
    }),
  }).catch(() => {});
}
